import { Injectable } from '@angular/core';
import { DebugModeService } from './debug-mode.service';
import { FeatureFlagService } from '../../services/feature-flags/feature-flag.service';

@Injectable({
    providedIn: 'root',
})
export class ComponentDebugFeatureService {
    constructor(
        private debugModeService: DebugModeService,
        private featureFlagService: FeatureFlagService
    ) {
        this.initFeatureFlag();
    }

    private initFeatureFlag(): void {
        // Check if the feature flag is enabled
        this.featureFlagService.isEnabled$('showComponentNames').subscribe((enabled) => {
            if (!enabled) {
                // If feature flag is disabled, make sure debug mode is off
                if (this.debugModeService.isEnabled) {
                    this.debugModeService.toggleComponentNames();
                }
            }
        });
    }

    public isFeatureEnabled(): boolean {
        return this.featureFlagService.isEnabled('showComponentNames');
    }
}
